
import { ReactNode, useReducer, FC } from 'react'
import { initialUIStatus } from '../assets/initialUIStatus'
import { ContextState } from '../types/context-types'
import { globalStateReducer } from '../reducers/globalstate-reducer'
import GlobalStateContext from './GlobalStateContext'

interface Props {
  children: ReactNode
}

const INITIAL_STATE: ContextState = {
  UIStatus: initialUIStatus,
  configSettings: { keyframeCollisionBehavior: 'overwrite',
                    keyframeWriteAtTimeBehavior: 'nearest_frame' },
  synergy: {
    easeIn: '',
    easeOut: '',
    getIn: false,
    getOut: false,
    display: false,
  },
  persistUI: {
    presetPanelLocked: false,
  },
  keysHeld: {
    shift: false,
    alt: false,
    ctrl: false,
  },
}

const NoteProvider: FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(globalStateReducer, INITIAL_STATE)

  return (
    <GlobalStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalStateContext.Provider>
  )
}

export default NoteProvider